<template>
  <div class="inline-block flex-shrink-0">
    <o-dropdown v-if="editable && !hasStatusType && hasStatusTypeOptions" class="inline-block">
      <o-chip
        flat
        icon="chevronDown"
        :size="size"
        icon-after
        hover
        placement="bottom-end"
      >
        {{ $t('general.status') }}
      </o-chip>

      <template #content>
        <div class="max-h-[min(30rem,var(--reka-popover-content-available-height,30rem))] overflow-y-auto overscroll-contain">
          <o-dropdown-item
            v-for="item in reservation.options.statusTypes"
            :key="item.idReservationStatusType"
            @click="currentValue = item"
          >
            {{ item.name }}
          </o-dropdown-item>
        </div>
      </template>
    </o-dropdown>

    <o-chip
      v-if="hasStatusType"
      flat
      :icon="editable ? 'x' : null"
      :size="size"
      :colour="colour"
      icon-after
      hover
      placement="bottom-end"
      @click="handleRemoveStatus"
    >
      {{ currentValue.name }}
    </o-chip>
  </div>
</template>

<script setup lang="ts">
import {
  ODropdownItem,
} from '@/components/elements'

interface Props {
  reservation: Record<string, any>
  modelValue?: Record<string, any> | null
  size?: string | null
  editable?: boolean
}

interface Emits {
  (e: 'update:modelValue', value: any): void
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  size: null,
  editable: false,
})

const emit = defineEmits<Emits>()

const currentValue = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

const hasStatusType = computed(() => !!props.modelValue)
const hasStatusTypeOptions = computed(() => !!props.reservation.options?.statusTypes?.length)
const isStatusCancelled = computed(() => props.reservation.isStatusCancelled)
const colour = computed(() => hasStatusType.value ? props.modelValue!.hexColour : null)

function handleRemoveStatus () {
  if (props.editable) {
    currentValue.value = null
  }
}
</script>
